import AdminAddDashboardsArea from '@src/main/ui/components/AdminAddDashboards/AdminAddDashboardsArea';
import { type FC } from 'react';

const AdminAddDashboardsAreaPage: FC = () => <AdminAddDashboardsArea />;

export default AdminAddDashboardsAreaPage;
